import React from "react"

import {FieldConditionFormProps} from "../../../render/condition/@types"
import {ConditionType} from "../../../../model2/conditions/condition-types"

export default class FieldProto_ConditionForm extends React.Component<FieldConditionFormProps> {

    onChangeType = (conditionType: ConditionType) => {
        this.props.condition.type = conditionType
        this.props.onChangeCallback(this.props.condition.type, this.props.condition.value)
    }

    onChangeValue = (value: any) => {
        this.props.condition.value = value
        this.props.onChangeCallback(this.props.condition.type, this.props.condition.value)
    }

    render() {
        return <div className="ui5-txt-default ui5-txt-red">{this.props.field.type}.conditionForm</div>
    }
}